import { cosmos, InstallError } from '@cosmostation/extension-client';
import { ErrorType, UnspecifiedErrorCode, CosmosWalletException, } from '@injectivelabs/exceptions';
export class CosmostationWallet {
    chainId;
    constructor(chainId) {
        this.chainId = chainId;
    }
    static async isChainIdSupported(chainId) {
        return new CosmostationWallet(chainId).checkChainIdSupport();
    }
    async checkChainIdSupport() {
        const { chainId: actualChainId } = this;
        const provider = await this.getCosmostationWallet();
        const chainName = actualChainId.split('-');
        try {
            const supportedChainIds = await provider.getSupportedChainIds();
            return !!supportedChainIds.official.find((chainId) => chainId === actualChainId);
        }
        catch {
            throw new CosmosWalletException(new Error(`Cosmostation doesn't support ${chainName[0] || actualChainId} network. Please use another Cosmos wallet`));
        }
    }
    async getCosmostationWallet() {
        try {
            const provider = await cosmos();
            return provider;
        }
        catch (e) {
            if (e instanceof InstallError) {
                throw new CosmosWalletException(new Error('Please install the Cosmostation extension'), {
                    code: UnspecifiedErrorCode,
                    type: ErrorType.WalletNotInstalledError,
                });
            }
            throw new CosmosWalletException(new Error(e.message), {
                code: UnspecifiedErrorCode,
            });
        }
    }
}
